import React from 'react';
import PropTypes from 'prop-types';
import flags from './flags';

const Flag = ({ code, size = '24px', alt = code }) => (
  <img width={size} className="ws-ui-flag" src={flags[code]} alt={alt} />
);

Flag.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  code: PropTypes.string.isRequired,
  // disable this rule in order to use `code` prop as default value
  // eslint-disable-next-line yola/react/require-default-props
  alt: PropTypes.string,
};

export default Flag;
